import type { LocationQueryRaw } from '#vue-router'
import getEstateMapRouteName from './getEstateMapRouteName'
import getEstateBaseRouteName from './getEstateBaseRouteName'
import type { EstateType } from '~/types/EstateType'

export default function getEstateListingLink({
  estateType,
  listingType = 'list',
  query,
}: {
  estateType: EstateType
  listingType?: 'list' | 'map'
  query?: LocationQueryRaw
}) {
  return useLocaleLink({
    name:
      listingType === 'map'
        ? getEstateMapRouteName(estateType)
        : getEstateBaseRouteName(estateType),
    query,
  })
}
